import redirect from "@rill/redirect";
import rill from "rill";
import ensureAthleteUpgrade from "../../middleware/ensure-athlete-upgrade";
import ensureCoachRedirection from "../../middleware/ensure-coach-redirection";
import ensureFirstTimeAthlete from "../../middleware/ensure-first-time-athlete";
import ensurePaid from "../../middleware/ensure-paid";
import ensureSetup from "../../middleware/ensure-setup";
import ensureUser from "../../middleware/ensure-user";
import { triggerClientSelfConfigMigration } from "../../middleware/trigger-client-config-migration";
import Calendar from "./calendar";
import Competitions from "./competitions";
import HomeDay from "./home-day";
import HomeWeek from "./home-week";
import Metrics from "./metrics";
import Notifications from "./notifications";
import Profile from "./profile/index";
import ProgramBuilder from "./program-builder";
import ProgramLibrary from "./program-library";
import Settings from "./settings";
import Support from "./support";

const Dashboard = (app) => {
  app.get("/dashboard", redirect("/dashboard/calendar")).at(
    "/dashboard/*",
    ensureUser,
    ensurePaid,
    ensureFirstTimeAthlete,
    ensureCoachRedirection,
    triggerClientSelfConfigMigration,
    ensureAthleteUpgrade,
    rill()
      .get(ensureSetup)
      .use(({ load }, next) =>
        load("listNotifications", {
          limit: false,
        }).then(next)
      )
      .setup(HomeDay)
      .setup(HomeWeek)
      .setup(Support)
      .setup(Settings)
      .setup(Metrics)
      .setup(ProgramBuilder)
      .setup(ProgramLibrary)
      .setup(Competitions)
      .setup(Notifications)
      .setup(Profile)
      .setup(Calendar)
  );
};

export default Dashboard;
